<template lang="html">
	<div class="rs-item-list">
		<div class="categories">
			<div 
				class="category" 
				v-for="(category, index) in options" 
				v-if="getItemCount(category)>0" 
				:key="category.id">
				<div class="row align-items-center">
					<div class="col-2">
						<category-image :files="category.ItemCategoryFiles" />
					</div>
					<div class="col">
						<h5>{{ category.name }}</h5>
						<span>{{ category.description }}</span>
					</div>
					<div class="col-3 text-right">
						Anzahl:
						<stepper 
							v-if="edit" 
							v-model="category.amount" 
							:min="0" 
							:max="getItemCount(category)" 
							@update="saveItems"/>
						<span 
							v-else 
							class="rs-amount">{{ category.amount }}</span>
					</div>
				</div>
			</div>
		</div>
		<div 
			class="categories special" 
			v-if="specialOptions.length>0">
			<h3>Zusatzoptionen</h3>
			<div 
				class="category special" 
				v-for="(category, index) in specialOptions"
				:key="category.id">
				<div class="row align-items-center">
					<div class="col-2">
						<category-image :files="category.ItemCategoryFiles" />
					</div>
					<div class="col">
						<h5>{{ category.name }}</h5>
						<span>{{ category.description }}</span>
					</div>
					<div class="col-3 text-right">
						Anzahl:
						<stepper 
							v-if="edit" 
							v-model="category.amount" 
							:min="0" 
							:max="getItemCount(category)" 
							@update="saveItems"/>
						<span v-else>{{ category.amount }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Gradient from './Gradient.vue'
import Stepper from './Stepper.vue'
import CategoryImage from './CategoryImage.vue'

export default {
	name: 'ItemList',
	components: {
		CategoryImage,
		Gradient,
		Stepper
	},
	props: {
		value: Array,
		edit: Boolean
	},
	computed: {
		specialOptions() {
			return this.value.filter(category => category.special)
		},
		options() {
			return this.value.filter(category => !category.special)
		}
	},
	methods: {
		saveItems() {
			this.$emit('save')
		},
		getItemCount(category) {
			if (!category.Items) return 0
			return category.Items.length
		}
	}
}
</script>

<style lang="css">
.rs-item-list svg{
    max-width: 75px;
    width: 100%;
    border-radius: 100%;
}
.rs-item-list .categories{
    margin-bottom: 25px;
}
.rs-item-list .category{
    padding: 25px 0;
    border-bottom: 2px solid black;
}
.rs-amount{
    font-size: 1.3em;
    font-weight: bold;
}
</style>
